import { useState } from 'react';
import { Skeleton } from 'antd';
const ImagePlaceholder = ({ src, alt, width, height = 250, fallback }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const imageSrc = error ? fallback : src;
  return (
    <>
      {src ? (
        <>
          {!loaded && <Skeleton.Image style={{ width : 400,height  }} size="large" active />}
          <img
            src={imageSrc}
            alt={alt}
            onLoad={() => setLoaded(true)}
            onError={() => {
              setError(true);
              setLoaded(true);
            }}
            style={{ objectFit: 'cover', width,height  }}
          />
        </>
      ) : (
        <>
          <img
            src={fallback}
            alt={alt}
            onLoad={() => setLoaded(true)}
            onError={() => {
              setError(true);
              setLoaded(true);
            }}
            style={{ objectFit: 'cover', width, height, }}
          />
        </>
      )}
    </>
  );
};

export default ImagePlaceholder;
